// extracted by mini-css-extract-plugin
module.exports = {"helpBubbleMessage":"styles_helpBubbleMessage__3icuX","blockWithHelpBuble":"styles_blockWithHelpBuble__ivZMg","helpIcon":"styles_helpIcon__2TCSf","infoBox":"styles_infoBox__1qvtk"};